"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoMeasureInputEvents = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var services_1 = require("../../services");
var code_enum_1 = require("../../services/input/code.enum");
var page_state_1 = require("../../state/page.state");
var PhotoMeasureInputEvents = /** @class */ (function () {
    function PhotoMeasureInputEvents(page, draw) {
        this.eventCount = {};
        this.renderOptions = null;
        this.page = page;
        this.draw = draw;
        this.eventContext = services_1.Services.Input.getContext();
    }
    PhotoMeasureInputEvents.prototype.incrementCount = function (title) {
        this.eventCount[title] = (this.eventCount[title] || 0) + 1;
    };
    PhotoMeasureInputEvents.prototype.init = function () {
        var _this = this;
        this.eventContext = services_1.Services.Input.getContext();
        this.eventContext.on(code_enum_1.Code.KeyS, this.saveCollection, { modifiers: { ctrl: true } });
        this.eventContext.on(code_enum_1.Code.ArrowUp, this.moveSelectedX.bind(this, -1));
        this.eventContext.on(code_enum_1.Code.ArrowUp, this.moveSelectedX.bind(this, -25), { modifiers: { shift: true } });
        this.eventContext.on(code_enum_1.Code.ArrowUp, this.moveSelectedX.bind(this, -0.25), { modifiers: { ctrl: true } });
        this.eventContext.on(code_enum_1.Code.ArrowDown, this.moveSelectedX.bind(this, 1));
        this.eventContext.on(code_enum_1.Code.ArrowDown, this.moveSelectedX.bind(this, 25), { modifiers: { shift: true } });
        this.eventContext.on(code_enum_1.Code.ArrowDown, this.moveSelectedX.bind(this, 0.25), { modifiers: { ctrl: true } });
        this.eventContext.on(code_enum_1.Code.ArrowLeft, this.moveSelectedY.bind(this, -1));
        this.eventContext.on(code_enum_1.Code.ArrowLeft, this.moveSelectedY.bind(this, -25), { modifiers: { shift: true } });
        this.eventContext.on(code_enum_1.Code.ArrowLeft, this.moveSelectedY.bind(this, -0.25), { modifiers: { ctrl: true } });
        this.eventContext.on(code_enum_1.Code.ArrowRight, this.moveSelectedY.bind(this, 1));
        this.eventContext.on(code_enum_1.Code.ArrowRight, this.moveSelectedY.bind(this, 25), { modifiers: { shift: true } });
        this.eventContext.on(code_enum_1.Code.ArrowRight, this.moveSelectedY.bind(this, 0.25), { modifiers: { ctrl: true } });
        var isIkeAnalyst = services_1.Services.User.current && services_1.Services.User.isIkeAnalyst(services_1.Services.User.current);
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_INSIGHT_AHOA) || isIkeAnalyst) {
            this.eventContext.on(code_enum_1.Code.KeyI, function () { return _this.draw.state.setInsightMarkersVisible(!_this.draw.state.visibleInsightMarkers); }, { modifiers: { ctrl: true } });
            this.eventContext.on(code_enum_1.Code.KeyM, function () { return _this.draw.state.setInsightMasksVisible(!_this.draw.state.visibleInsightMasks); }, { modifiers: { ctrl: true } });
        }
        this.eventContext.on(code_enum_1.Code.Escape, this.clearSelected);
        // Arrange Annotations
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_ANNOTATIONS_ARRANGE) ||
            (isIkeAnalyst)) {
            this.eventContext.on(code_enum_1.Code.KeyA, function (e) {
                if (!_this.renderOptions || !_this.draw) {
                    return;
                }
                e.event.preventDefault();
                _this.draw.state.arrangeAnnotations(_this.renderOptions);
            }, { modifiers: { ctrl: true, shift: true } });
        }
    };
    PhotoMeasureInputEvents.prototype.getSelectedObject = function () {
        if (this.draw == null) {
            return null;
        }
        return this.draw.selected;
    };
    PhotoMeasureInputEvents.prototype.trackEvents = function () {
        var _a;
        for (var _i = 0, _b = Object.keys(this.eventCount); _i < _b.length; _i++) {
            var eventLabel = _b[_i];
            var value = this.eventCount[eventLabel];
            if (value == null || value === 0) {
                continue;
            }
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Collection, eventLabel, (_a = page_state_1.CurrentState.inspectedCaptureId) !== null && _a !== void 0 ? _a : undefined, value);
        }
    };
    PhotoMeasureInputEvents.prototype.clearSelected = function (evt) {
        page_state_1.CurrentState.cancelInteractions();
        this.incrementCount('keyboard:clear');
        var selected = this.getSelectedObject();
        if (selected == null) {
            return;
        }
        this.draw.state.setSelected(null, null);
    };
    PhotoMeasureInputEvents.prototype.saveCollection = function (evt) {
        if (this.draw == null) {
            return;
        }
        evt.event.preventDefault();
        this.incrementCount('keyboard:save');
        this.page.editControl.saveChanges(evt.event);
    };
    PhotoMeasureInputEvents.prototype.deleteSelected = function (evt) {
        var selected = this.getSelectedObject();
        if (selected == null || !this.draw.state.selectedId) {
            return;
        }
        this.incrementCount('keyboard:delete');
        core_shared_1.IkeDrawBindings.Measurement.delete(this.draw, { drawableId: this.draw.state.selectedId, $event: evt.event });
    };
    PhotoMeasureInputEvents.prototype.moveSelectedX = function (dy, evt) {
        var selected = this.getSelectedObject();
        if (selected == null) {
            return;
        }
        if (!this.renderOptions || !this.draw) {
            return;
        }
        var isUp = dy < 0;
        this.incrementCount("keyboard:move:".concat(isUp ? 'up' : 'down', ":").concat(Math.abs(dy)));
        core_shared_1.IkeDrawBindings.Selection.move(this.draw, { delta: { x: 0, y: dy }, $event: evt.event });
        if (this.draw.state.autoArrangeAnnotations) {
            this.draw.state.arrangeAnnotations(this.renderOptions);
        }
    };
    PhotoMeasureInputEvents.prototype.moveSelectedY = function (dx, evt) {
        var selected = this.getSelectedObject();
        if (selected == null) {
            return;
        }
        var isLeft = dx < 0;
        this.incrementCount("keyboard:move:".concat(isLeft ? 'left' : 'right', ":").concat(Math.abs(dx)));
        // Don't allow keyboard events to move labels
        var selectedRegion = this.draw.state.selectedRegion;
        var label = selectedRegion === 'label' ? null : selectedRegion;
        core_shared_1.IkeDrawBindings.Selection.move(this.draw, { delta: { x: dx, y: 0 }, $event: evt.event, label: label !== null && label !== void 0 ? label : undefined });
    };
    PhotoMeasureInputEvents.prototype.destroy = function () {
        if (this.eventContext != null) {
            this.eventContext.destroy();
        }
    };
    tslib_1.__decorate([
        mobx_1.action.bound
    ], PhotoMeasureInputEvents.prototype, "clearSelected", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], PhotoMeasureInputEvents.prototype, "saveCollection", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], PhotoMeasureInputEvents.prototype, "deleteSelected", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PhotoMeasureInputEvents.prototype, "moveSelectedX", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PhotoMeasureInputEvents.prototype, "moveSelectedY", null);
    return PhotoMeasureInputEvents;
}());
exports.PhotoMeasureInputEvents = PhotoMeasureInputEvents;
//# sourceMappingURL=pm.events.js.map